import type { Signal } from "@builder.io/qwik";
import { createContextId } from "@builder.io/qwik";
import { type CoachSelect } from "~/lib/schemas";
import {
  type CoachDetailsSelect,
  type ProfileSelect,
} from "../../drizzle/schema";

export const CoachContext = createContextId<Signal<CoachSelect>>(
  "com.dreamcoachmatch.coach",
);

export const CoachProfileContext = createContextId<
  Signal<CoachSelect & { profile: ProfileSelect; details: CoachDetailsSelect }>
>("com.dreamcoachmatch.coach-profile");
